var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1300,
    height: 65.825,
    viewBox: "0 0 1300 65.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.002,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc89be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#47a5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02c738"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,65.825V57.707A18.059,18.059,0,0,1,18.054,39.649H534.946C560.236,15.738,601.5,0,648.222,0s87.986,15.738,113.271,39.649H1281.94A18.06,18.06,0,0,1,1300,57.707v8.118h-9.684V57.707a8.375,8.375,0,0,0-8.376-8.375H757.56l-1.409-1.387c-23.633-23.2-63.18-38.262-107.929-38.262s-84.3,15.058-107.929,38.262l-1.415,1.387H18.054a8.375,8.375,0,0,0-8.371,8.375v8.118Z",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLine);
export default __webpack_public_path__ + "static/media/topLine.bf03884e96e986af2febb612d1fe2590.svg";
export { ForwardRef as ReactComponent };